import { useState } from "react";

export default function useInput(validateMethod) {
  const [input, setInput] = useState({ value: "", isValid: true });

  function getInputValue(event) {
    const inputType = event.target.type;
    let inputValue = event.target.value || "";
    if (inputType === "tel") {
      inputValue = inputValue.replace(/\D+/g, "");
    }
    return inputValue;
  }

  function onInputChange(event) {
    const inputValue = getInputValue(event);
    setInput({ ...input, value: inputValue, ...validateMethod(inputValue) });
  }

  return [input, setInput, onInputChange];
}
